// This module provides API call methods for Sephora Stay Signed-in APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Stay+Signed-in+Specification

import autoLogin from 'services/api/ssi/autoLogin';

export default { autoLogin: autoLogin.autoLogin };
